/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsmePDcMJkefp } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: MePDcM-JKEFP/globalVariant
import { LocaleValue, useLocale } from "./PlasmicGlobalVariant__Locale"; // plasmic-import: xaTYt-pNktxD/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsmePDcMJkefp,
  locale: useLocale
});
